// Lib Imports
import React from 'react';
import { Box, Stack, Text } from 'grommet';
import PropTypes from 'prop-types';
import DropMenu from 'granite-admin/core/components/DropMenu';
import { withTheme, createGlobalStyle } from 'styled-components';
const GlobalStyles = createGlobalStyle`
  .drop-box-drop {
    left: auto !important;
    right: ${({
  isCollapsed
}) => `calc(100vw - ${isCollapsed ? '498px)' : '696px)'} !important;`}
  }
  .drop-box-drop-right {
    right: auto !important;
    left: ${({
  isCollapsed
}) => `calc(100vw - ${isCollapsed ? '498px)' : '696px)'} !important;`}
  }
`;
const DropBox = ({
  isCollapsed,
  theme,
  data,
  sidebarPosition
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyles, {
    isCollapsed: isCollapsed
  }), /*#__PURE__*/React.createElement(DropMenu, {
    icon: /*#__PURE__*/React.createElement(Stack, {
      anchor: "top-right"
    }, data.icon),
    isCollapsed: isCollapsed,
    label: /*#__PURE__*/React.createElement(Text, null, data.label),
    dropProps: {
      className: sidebarPosition === 'right' ? 'drop-box-drop-right' : 'drop-box-drop',
      style: {
        backgroundColor: '#fff',
        transition: 'all 0.5s ease 0s',
        borderRadius: '6px',
        boxShadow: 'rgb(0 0 0 / 10%) 0px 4px 17px 6px'
      }
    },
    dropAlign: {
      bottom: 'bottom',
      left: 'none'
    },
    renderItems: () => /*#__PURE__*/React.createElement(DropBoxContent, {
      data: data
    })
  }));
};
const DropBoxContent = ({
  data
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    background: "sidebar-drops",
    width: data.width,
    height: data.height,
    overflow: {
      vertical: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    flex: {
      shrink: 0
    },
    background: "brand",
    pad: "medium",
    justify: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "white",
    weight: "600"
  }, data.label)), /*#__PURE__*/React.createElement(Box, {
    pad: "medium",
    flex: {
      grow: 1
    }
  }, data.content));
};
DropBox.propTypes = {
  isCollapsed: PropTypes.bool,
  theme: PropTypes.object,
  data: PropTypes.object,
  sidebarPosition: PropTypes.string
};
DropBoxContent.propTypes = {
  data: PropTypes.object
};
export default withTheme(DropBox);